/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ParameterConstraintForNumericRange extends models.ParameterConstraintBaseForNumber {
    constructor() {
        super();
        this.setDiscriminator("ParameterConstraintForNumericRange");
    }

    getFixupPrototypeFunction() { return ParameterConstraintForNumericRange.fixupPrototype; }

    static newInstance(model: Partial<ParameterConstraintForNumericRange>): ParameterConstraintForNumericRange {
        let obj = Object.assign(new ParameterConstraintForNumericRange(), model);
        ParameterConstraintForNumericRange.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ParameterConstraintForNumericRange>): ParameterConstraintForNumericRange {
        if (!model) return null;
        return ParameterConstraintForNumericRange.newInstance(<ParameterConstraintForNumericRange> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ParameterConstraintForNumericRange) {
        if (!obj) return;

        models.ParameterConstraintForNumericRange.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ParameterConstraintForNumericRange): boolean {
        if (models.ParameterConstraintBaseForNumber.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, ParameterConstraintForNumericRange.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
        if (this.min === undefined) {
            this.min = 0;
        }
        if (this.max === undefined) {
            this.max = 0;
        }
    }

    /**
     * Minimum value of the parameter's constraint field
     */
    min: number;

    /**
     * Maximum value of the parameter's constraint field
     */
    max: number;

}
